import { showRequestError } from '../../utils/request-feedback';
import { PermissionControl } from '../../permissions/access';
import { useEffect, useState } from 'react';
import { fetchAssetClass, createAssetClass, updateAssetClass, deleteAssetClass } from "../../api/privatemarket";
import { Table, message, Typography, Flex, Button, Popconfirm, Pagination, Tag, Select } from 'antd';
import { useDebouncedCallback } from 'use-debounce';


const PMAssetClassScreen = () => {
    const [pageNum, setPageNum] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [total, setTotal] = useState(0);
    const [searchParams, setSearchParams] = useState({
        status: '',
    });

    const tabCols = [
        {
            title: 'Index',
            dataIndex: 'id',
            key: 'id',
            render: (text, _, index) => (index + 1),
        },
        {
            title: 'Asset Class Name',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => {
                let val = record.name;
                return <PermissionControl permission="assetclass.control.inline.2ba9948e" actionOnly variant={Number(record.id) > 0 ? 'update' : 'create'}><Typography.Text editable={
                    {
                        onChange: (value) => {
                            val = value;
                        },
                        onEnd: () => {
                            editHandle(Number(record.id) > 0 ? { id: record.id, name: val } : { ...record, name: val });
                        }
                    }
                }>{text}</Typography.Text></PermissionControl>
            },
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            render: (text, record) => {
                let val = record.description;
                return <PermissionControl permission="assetclass.control.inline.5d7ddaed" actionOnly variant={Number(record.id) > 0 ? 'update' : 'create'}><Typography.Text style={{ fontSize: 12, color: '#afafaf' }} editable={
                    {
                        onChange: (value) => {
                            val = value;
                        },
                        onEnd: () => {
                            editHandle(Number(record.id) > 0 ? { id: record.id, description: val } : { ...record, description: val });
                        }
                    }
                }>{text}</Typography.Text></PermissionControl>
            },
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text, record) => {
                if (String(text) === '0') return <Tag color='success'>Active</Tag>;
                return <Tag color='warning'>Inactive</Tag>
            },
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => {
                return (
                    <Button.Group size='small'>
                        {
                            parseInt(record.id) > 0 && <PermissionControl permission="assetclass.control.activeHandle.bde950ec"><Button type='link' onClick={() => { activeHandle(record) }}>{String(record.status) === '0' ? 'Inactive' : 'Active'}</Button></PermissionControl>
                        }
                        <PermissionControl permission="assetclass.control.deleteHandle.4008df8b"><Popconfirm
                            title="Delete Action"
                            description="Are you sure to delete this asset class?"
                            onConfirm={() => { deleteHandle(record) }}
                            okText="Yes"
                            cancelText="No" >
                            <Button danger type='link'>Delete</Button>
                        </Popconfirm></PermissionControl>
                    </Button.Group>
                )
            }
        }
    ];

    const [tabData, setTabData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchData(pageNum, pageSize, searchParams);
    }, []);

    const fetchData = (pNum, pSize, search) => {
        setLoading(true);
        fetchAssetClass({ 'page.num': pNum, 'page.size': pSize, ...search }).then(res => {
            if (res.list) {
                setTabData(res.list);
            }
            if (res.page) {
                setTotal(res.page.total);
            }
        }).finally(() => setLoading(false)).catch(showRequestError)
    }

    const deleteHandle = (item) => {
        if (parseInt(item.id) <= 0) {
            setTabData([...tabData].filter(old => old !== item));
            return;
        }
        setLoading(true);
        deleteAssetClass(item.id).then(res => {
            if (res) {
                message.success('deleted!');
                setLoading(false);
                fetchData(pageNum, pageSize, searchParams);
            }
        }).catch((err) => {
            showRequestError(err, err?.message);
            setLoading(false);
        })
    }

    const editHandle = (params) => {
        setLoading(true);
        if (parseInt(params.id) > 0) {
            updateAssetClass(params).then(res => {
                if (res) {
                    message.success('updated!');
                    fetchData(pageNum, pageSize, searchParams);
                }
            }).finally(() => setLoading(false)).catch(showRequestError);
        } else {
            let newParams = { ...params };
            delete newParams['id'];
            createAssetClass(newParams).then(res => {
                if (res) {
                    message.success('created!');
                    fetchData(pageNum, pageSize, searchParams);
                }
            }).finally(() => setLoading(false)).catch(showRequestError);
        }
    }

    const activeHandle = (item) => {
        let params = { id: item.id, status: String(item.status) === '0' ? 1 : 0 };
        setLoading(true);
        updateAssetClass(params).then(res => {
            if (res) {
                fetchData(pageNum, pageSize, searchParams);
            }
        }).finally(() => {
            setLoading(false);
        }).catch(showRequestError);
    }

    const addNewAssetClass = () => {
        if (tabData.findIndex(item => item.id === '-1') >= 0) return;
        setTabData([
            {
                id: '-1',
                name: '',
                description: '',
            }, ...tabData
        ]);
    }

    const pageChange = (page, size) => {
        setPageNum(page);
        setPageSize(size);
        fetchData(page, size, searchParams);
    }

    const onSearchChange = useDebouncedCallback(
        (tag, value) => {
            let newParams = { ...searchParams };
            newParams[tag] = value;
            setSearchParams(newParams);
            setPageNum(1);
            fetchData(1, pageSize, newParams);
        },
        300
    )

    return (
        <div>
            <Flex justify='space-between' style={{ padding: 10 }}>
                <PermissionControl permission="assetclass.control.button.105ec338"><Button type='primary' onClick={addNewAssetClass}>Create New AssetClass</Button></PermissionControl>
                <Select
                    style={{ width: 160 }}
                    options={[
                        { key: 1, value: 0, label: 'Active' },
                        { key: 1, value: 1, label: 'Inactive' },
                    ]}
                    placeholder='Status'
                    onChange={value => onSearchChange('status', value)}
                    allowClear
                />
            </Flex>
            <div className='cnt-item'>
                <Table
                    scroll={{ x: true }}
                    loading={loading}
                    rowKey={(record) => record.id}
                    rowClassName={'table-row'}
                    size='small'
                    dataSource={tabData}
                    columns={tabCols}
                    pagination={false} />
            </div>

            <div className='footer-part cnt-item'>
                <Pagination
                    total={total}
                    showTotal={(total) => `total ${total}`}
                    current={pageNum}
                    pageSize={pageSize}
                    showSizeChanger={true}
                    pageSizeOptions={[10, 20, 30, 50]}
                    onChange={(page, size) => pageChange(page, size)}
                />
            </div>
        </div>
    )
}
export default PMAssetClassScreen;